import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CmsConfig, ConfigModule } from '@spartacus/core';
import { SiteLogoComponent } from './site-logo.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ConfigModule.withConfig({
      cmsComponents: {
        SimpleBannerComponent: {
          component: SiteLogoComponent,
        },
      },
    } as CmsConfig),
    SiteLogoComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SiteLogoModule {}
